import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, getOrgId } from '../../services/api';
import { PageContainer } from '../../components/ui/PageLayout';
import { PageToolbarSkeleton } from '../../components/ui/Skeleton';

const Profile = () => {
  const navigate = useNavigate();
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const userId = getCurrentUser()?.id;
    if (!userId) {
      setShowFallback(true);
      return undefined;
    }
    getOrgId()
      .then((orgId) => {
        if (cancelled) return;
        if (orgId) {
          navigate(`/members/${userId}`, { replace: true });
        } else {
          setShowFallback(true);
        }
      })
      .catch(() => {
        if (!cancelled) setShowFallback(true);
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (showFallback) {
    return (
      <PageContainer>
        <p className="text-slate-400">
          Could not load your profile. Sign in again or complete organisation setup.
        </p>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageToolbarSkeleton />
    </PageContainer>
  );
};

export default Profile;
